import { diContainer } from '../libs/container';
import { ApiBaseClass, IServiceHttp } from './ApiBase';
import { EmployeeLeaveBalanceDto, ReportsPage, TopEmployeesByRemainingDaysDto } from '../commonTypes/reports.types';

export type TrendDirection = 'up' | 'down' | 'neutral';

export interface TrendDto {
    value: number;
    direction: TrendDirection;
}

export namespace AbsenceReportApiRequest {
    export interface EmptyRequest {}

    export interface GetEmployeeLeaveBalance {
        query: {
            leaveType: string;
            search?: string;
            page: number;
            size: number;
        };
    }

    export interface GetTopEmployeeLeaveBalance {
        query: {
            leaveType: string;
            teamId?: string;
            search?: string;
            sort: 'remainingDesc' | 'remainingAsc';
            page: number;
            size: number;
        };
    }
}

export namespace AbsenceReportApiResponse {
    export type GetOverview =
        | {
              body: {
                  dataAvailable: true;
                  totalAbsences: number;
                  totalAbsencesTrend: TrendDto;
                  onLeaveToday: number;
                  onLeaveTodayTrend: TrendDto;
                  totalEmployees: number;
              };
          }
        | {
              body: {
                  dataAvailable: false;
              };
          };

    export interface GetEmployeeLeaveBalance {
        body: ReportsPage<EmployeeLeaveBalanceDto>;
    }

    export interface GetTopEmployeeLeaveBalance {
        body: ReportsPage<TopEmployeesByRemainingDaysDto>;
    }
}

export class AbsenceReportApi {
    constructor(private readonly apiBase: ApiBaseClass) {}

    public getOverview(rest: IServiceHttp<AbsenceReportApiRequest.EmptyRequest, AbsenceReportApiResponse.GetOverview>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'usr/v1/reports/absence/overview',
        });
    }

    public triggerCompute(rest: IServiceHttp<AbsenceReportApiRequest.EmptyRequest, void>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'usr/v1/reports/absence/compute',
        });
    }

    public getEmployeeLeaveBalance(
        rest: IServiceHttp<AbsenceReportApiRequest.GetEmployeeLeaveBalance, AbsenceReportApiResponse.GetEmployeeLeaveBalance>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'usr/v1/reports/absence/leave-balance',
        });
    }

    public getTopEmployeeLeaveBalance(
        rest: IServiceHttp<AbsenceReportApiRequest.GetTopEmployeeLeaveBalance, AbsenceReportApiResponse.GetTopEmployeeLeaveBalance>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'usr/v1/reports/absence/leave-balance/top',
        });
    }
}

diContainer.bindAsDynamic(AbsenceReportApi, c => new AbsenceReportApi(c.get(ApiBaseClass)));
